import { render } from "./pro-success.vue?vue&type=template&id=26dde218&scoped=true"
import script from "./pro-success.vue?vue&type=script&lang=js"
export * from "./pro-success.vue?vue&type=script&lang=js"

import "./pro-success.vue?vue&type=style&index=0&id=26dde218&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26dde218"

export default script